var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { Radio as ArcoRadio, ConfigProvider as ArcoConfigProvider } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import Radio from './radio';
import Child from './children';
import './style/group.less';
function isPresetGapSize(gapSize) {
    return (gapSize === 'small' || gapSize === 'middle' || gapSize === 'large' || gapSize === 'default');
}
var Group = function (props) {
    var _a;
    var options = props.options, _b = props.gapSize, gapSize = _b === void 0 ? 'default' : _b, _c = props.type, type = _c === void 0 ? 'radio' : _c, _d = props.size, size = _d === void 0 ? 'default' : _d, _e = props.warp, warp = _e === void 0 ? false : _e, _f = props.lineFeed, lineFeed = _f === void 0 ? true : _f, _g = props.compact, compact = _g === void 0 ? false : _g, _h = props.error, groupError = _h === void 0 ? false : _h;
    var ConfigContext = ArcoConfigProvider.ConfigContext;
    var ctx = useContext(ConfigContext);
    var newOptions = Array.isArray(options)
        ? options === null || options === void 0 ? void 0 : options.map(function (option) {
            if (Object.prototype.toString.call(option) === '[object Object]') {
                var _a = option, disabled = _a.disabled, icon = _a.icon, tooltipContent = _a.tooltipContent, description = _a.description, value = _a.value, label = _a.label, error = _a.error;
                return {
                    value: value,
                    disabled: !!disabled,
                    error: error,
                    label: (React.createElement(Child, { disabled: !!disabled, icon: icon, tooltipContent: tooltipContent, description: description }, label)),
                };
            }
            return {
                label: React.createElement(Child, null, option),
                value: option,
            };
        })
        : undefined;
    var mergedProps = __assign(__assign({}, props), { options: undefined });
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-radio-group"), gapSizeCls = "".concat(prefixCls, "-gap-size-").concat(gapSize), warpCls = "".concat(prefixCls, "-warp"), arcoRadioGroupInline = "".concat(ctx.prefixCls, "-radio-group-inline"), compactCls = "".concat(prefixCls, "-compact");
    var handleChildren = React.Children.map(props.children, function (child) {
        if (groupError) {
            return React.cloneElement(child, {
                className: "".concat(ctx.prefixCls, "-radio-error"),
            });
        }
        return child;
    });
    return (React.createElement(ArcoRadio.Group, __assign({ "data-tid": "m4b_radio_group" }, mergedProps, { className: cx(prefixCls, "".concat(prefixCls, "-size-").concat(size), mergedProps.className, type === 'radio' && isPresetGapSize(gapSize) && gapSizeCls, warp && warpCls, compact && compactCls, !lineFeed && arcoRadioGroupInline), style: __assign({ gap: !isPresetGapSize(gapSize) ? gapSize : undefined }, ((_a = mergedProps.style) !== null && _a !== void 0 ? _a : {})), size: size === 'abnormal' ? 'large' : size }), handleChildren ||
        (newOptions === null || newOptions === void 0 ? void 0 : newOptions.map(function (v) { return (React.createElement(Radio, { key: v.value, value: v.value, disabled: v.disabled, error: v.error || groupError }, v.label)); }))));
};
Group.displayName = 'Radio.Group';
export default Group;
